// KWANKGM02050_借入相談同意不同意（受付完了）
import React from 'react';
import HeadingM from '../../molecules/HeadingM';

const BorrowingConsultationContentInquiryFinalBody: React.FC = () => {
  const url = location.href.split('/');
  const agreement = url.pop();

  // 本文内の同意／不同意の文言を返却する
  const setAgreeStr = () => {
    // 同意の場合
    if (agreement === 'agree') {
      return '同意';
    }

    // 不同意の場合
    return '不同意';
  };

  return (
    <>
      <HeadingM label="確認完了" />
      <p className="mt-3">
        借入相談内容のご確認ありがとうございます。
        <br />
        借入相談内容に{setAgreeStr()}として受け付けました。
        <br />
        ウインドウまたはタブを閉じて下さい。
        <br />
      </p>
    </>
  );
};

export default BorrowingConsultationContentInquiryFinalBody;
